/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { useFormContext } from "react-hook-form";

// CSS読み込み
import {
  inputArea_textarea,
  inputArea_textarea_error,
} from "assets/css/stylesCss";
import { getProhibitedCharacters } from "utilities/getProhibitedCharacters";
import ValidationErrorText from "../validation/ValidationErrorText";

/**
 * テキストエリア
 * @param {String} name react-hook-form管理用フォーム特定文字列
 * @param {String} placeholder プレースホルダー表示用文字列
 * @param {Number} maxLength 最大文字数
 * @param {String} inputMode 入力されるデータの型
 * @param {Object} rules バリデーション設定オブジェクト
 */
const InputTextArea = memo(({ name, placeholder, maxLength, inputMode, rules }) => {
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
  } = useFormContext();

  return (
    <>
      <div>
        <textarea
          {...register(name, {
            ...rules,
            validate: {
              // 禁止文字チェック
              isOnlyAllowedCharacters: (value) => {
                if (getProhibitedCharacters(value).length === 0) {
                  return true;
                } else {
                  return "利用できない文字が含まれています。";
                }
              },
            },
            onBlur: () =>
              // 前後のスペースを削除し設定
              setValue(name, getValues(name).trim()),
            onChange: () =>
              setValue(name, getValues(name), {
                shouldValidate: true,
              }),
          })}
          css={errors[name] ? inputArea_textarea_error : inputArea_textarea}
          placeholder={placeholder}
          maxLength={maxLength ? maxLength : ""}
          inputMode={inputMode ? inputMode : ""}
        ></textarea>
      </div>
      {/* エラーメッセージ **/}
      {errors[name] && (
        <ValidationErrorText>{errors[name].message}</ValidationErrorText>
      )}
    </>
  );
});

export default InputTextArea;
